






























































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {RGBA} from "@/@types/data";
import {Value} from './ExposomeGlobeDrawer'

@Component({components: {}})
export default class ExposomeGlobeDrawer extends Vue {
    $refs!: {};
    @Prop(Object) value!: Value;
    private internalValue: Value = this.value;
    private lockOpen = false;
    private invalidOptions = false;
    private optionsString = JSON.stringify(this.value);
    private colorPickerOptions = {
        mode: "rgba",
        "show-swatches": true,
        swatches: [
          ['#1f77b4', '#aec7e8', '#ff7f0e', '#ffbb78', ],
          ['#2ca02c', '#98df8a', '#d62728', '#ff9896', ],
          ['#9467bd', '#c5b0d5', '#8c564b', '#c49c94', ],
          ['#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', ],
          ['#bcbd22', '#dbdb8d', '#17becf', '#9edae5', ],
        ],
        "hide-inputs": false,
    };
    private sortOptions = [
        {text: "Order in File", value: "none"},
        {text: "Domain size", value: "value"},
    ];

    input(key: keyof Value, val: number & RGBA ): void {
        this.internalValue[key] = val;
        this.$emit('input', this.internalValue);
        this.resetOptions();
        //this.lockOpen = false;
    }

    resetOptions(): void {
        this.optionsString = JSON.stringify(this.internalValue);
        this.invalidOptions = false;
    }

    @Watch('optionsString')
    parseOptions(options: string): void {
        try {
            this.invalidOptions = false;
            const value = JSON.parse(options);
            if (typeof value === 'object' && Object.keys(this.internalValue).every(v=>v in value)) {
              Object.assign(this.internalValue, value);
            } else {
                this.invalidOptions = true;
            }
        } catch (e) {
            this.invalidOptions = true;
        }
    }
}
